// @/utils/pagination.ts
export const deriveTotal = (
  page: number,
  size: number,
  received: number
): number =>
  received === size
    ? page * size + 1          // full page → assume a next page exists
    : (page - 1) * size + received; // short page → this is the last page